/**
 * What a key press in the command box means.
 *
 * Enter sends and Shift+Enter starts a new line, which is what every chat the
 * owner uses already does. The one that is easy to get wrong: an input method
 * - Japanese, Chinese, Korean, and the accent pickers - sends Enter to COMMIT
 * the characters being composed, and treating that as "send" posts half a word.
 * The browser flags it, so the flag is what is checked.
 */

export interface KeyIntent {
  readonly key: string;
  readonly shiftKey: boolean;
  /** True while an input method is still composing the text. */
  readonly isComposing: boolean;
  readonly altKey?: boolean;
  readonly ctrlKey?: boolean;
  readonly metaKey?: boolean;
}

/** Does this key press mean "send it"? */
export function sendsOnEnter(event: KeyIntent): boolean {
  if (event.key !== 'Enter') return false;
  if (event.isComposing) return false;
  if (event.shiftKey || event.altKey === true || event.ctrlKey === true || event.metaKey === true) return false;
  return true;
}
